module.exports = __webpack_public_path__ + "img/toplogo.af0c39f4.png";